
import PropTypes from 'prop-types'
import React from 'react'
import withBodyScrollDisabled from './withBodyScrollDisabled'
import './Modal.css'

const Modal = props => {
  const { children, onClose, overlayStyle } = props

  return (
    <div>
      <div className='Modal'>
        <div className='Modal-overlay' onClick={onClose} style={overlayStyle} />
        <div className='Modal-wrapper'>{children}</div>
      </div>
    </div>
  )
}

Modal.displayName = 'Modal'

Modal.propTypes = {
  children: PropTypes.element.isRequired,
  onClose: PropTypes.func.isRequired,
  overlayStyle: PropTypes.object
}

export default withBodyScrollDisabled(Modal)



// WEBPACK FOOTER //
// ./ui/Modal.js